var DOC = document;

var CORE = {

	className: 'brtn-popup',

	element: null,

	options: {

		classNames: null,

		onClose: null,

	},

	loadElement: function () {
		var o = '';
		var classNames;

		if (CORE.element !== null) {
			return;
		}
		classNames = CORE.options.classNames;
		classNames = typeof classNames === 'object' && classNames !== null && 'length' in classNames && classNames.length > 0 ? classNames : [];
		classNames.unshift(CORE.className);

		o += '<div class="' + CORE.className + '__inner">';
		o += '<div class="' + CORE.className + '__header"></div>';
		o += '<div class="' + CORE.className + '__body"></div>';
		o += '</div>';

		CORE.element = DOC.createElement('div');
		CORE.element.className = classNames.join(' ');
		CORE.element.innerHTML = o;

	},

	setHeader: function (title, close) {
		var o = '';

		CORE.loadElement();

		close = typeof close === 'boolean' ? close : true;

		if (typeof title === 'string' && title.length) {
			o += '<h4 class="' + CORE.className + '__header__title">' + title + '</h4>';
		}

		if (close) {
			o += '<button class="' + CORE.className + '__header__close">';
			o += '<span class="brtn-icon brtn-icon--close"></span>';
			o += '<span class="' + CORE.className + '__header__close__txt">Fermer</span>';
			o += '</button>';
		}

		CORE.element.firstChild.firstChild.innerHTML = o;

		if (close) {
			CORE.element.firstChild.firstChild.lastChild.addEventListener('click', function (e) {
				CORE.hide();

				if (typeof CORE.options.onClose === 'function') {
					CORE.options.onClose(e);
				}
			});
		}

	},

	setBody: function (content) {

		if (typeof content !== 'string') {
			return;
		}
		CORE.loadElement();

		CORE.element.firstChild.lastChild.innerHTML = content;

	},

	show: function () {
		var loading = DOC.getElementsByClassName(CORE.className);;

		CORE.loadElement();

		if (typeof loading === 'object' && loading != null && loading.length) {
			return;
		}
		DOC.body.appendChild(CORE.element);

	},

	hide: function () {
		var loading = DOC.getElementsByClassName(CORE.className);;

		CORE.loadElement();

		if (typeof loading !== 'object' || loading == null || !loading.length) {
			return;
		}
		DOC.body.removeChild(CORE.element);

	},

	setOption: function (name, value) {

		if (typeof name !== 'string' || !(name in CORE.options)) {
			return false;
		}
		CORE.options[name] = value;
		return true;
	},

	getNode: function () {

		CORE.loadElement();

		return CORE.element;

	}

};

export default {
	getNode: CORE.getNode,
	setOption: CORE.setOption,
	setHeader: CORE.setHeader,
	setBody: CORE.setBody,
	show: CORE.show,
	hide: CORE.hide
};
